var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-content"},[_c('breadcrumb',{attrs:{"list":_vm.breadcrumbList}}),_c('div',{staticClass:"margintop-32"}),_c('btn',{attrs:{"text":"Reports Module","type":"primary"},on:{"click":_vm.goToReports}}),_c('br'),_c('btn',{attrs:{"text":"Payroll Report","type":"primary"},on:{"click":_vm.goToPayrollReport}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }